import "./review.scss";
import FormTitle from "../components/formTitle/FormTitle";
import axios from "axios";
import Config from "../common/Config";
import Review from "./Review";
import SecondaryButton from "../components/button/SecondaryButton";
import Button from "../components/button/Button";

class SimpleCartReview extends Review {
  constructor(props) {
    super(props);

    this.linerBundleFormTypeId = 14;

    this.state = {
      cartData:[]
    };
  }

  componentDidMount() {
    super.componentDidMount();
    this.loadData();
  }

  async loadData() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };

      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let cartData = (
        await axios.get(
          Config.baseApiUrl + "cart/" + this.props.formTypeId,
          config
        )
      ).data;

      config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
          UniqueId: this.props.uniqueId,
        },
        params: {
          fieldNames: ["linerPromiseShipDates"],
        },
      };

      const fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          config
        )
      ).data;

      if (fieldInputs === null) {
        if (parseInt(this.props.formTypeId) === this.linerBundleFormTypeId) {
          const linerPartNumbers = cartData.map(cd => {
            return cd.partNumber
          })

          let linerShipDateConfig = {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
            },
            params: {
              linerPartNumbers: linerPartNumbers,
            },
          };

          let shippingDates = (
            await axios.get(
              Config.baseApiUrl + "linerShipDate/",
              linerShipDateConfig
            )
          ).data;

          cartData.map(cd => {
            cd.scheduledShipDate = this.formatShipDate(shippingDates.find((sd) => sd.linerPartNumber === cd.partNumber) ?? "");
            return cd;
          })
        } else {
          cartData.map(cd => {
            return cd;
          })
        }
      } else {
        let parsedFieldOptions = fieldInputs.map(fi => {
          fi.stringData = JSON.parse(fi.stringData);
          return fi;
        });
        cartData.map(cd => {
          const cartFieldInput = parsedFieldOptions.find((fi) => fi.stringData.fieldInputId === cd.fieldInputId);
          cd.scheduledShipDate = cartFieldInput.stringData.shipDate;
          return cd;
        })
      }

      this.setState({
       cartData:cartData
      });
    } catch (error) {
      console.log(error);
    }
    
    super.loadData();
    this.setState({ isLoaded: true });
  }

  async saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    let data = [];

    this.state.cartData.forEach(cartItem => {
      data.push({
        fieldName: "LinerPromiseShipDates",
        stringData: JSON.stringify({fieldInputId: cartItem.fieldInputId, shipDate: cartItem.scheduledShipDate}),
      });
    });

    await axios.post(
      Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
      data,
      config
    );

    await axios.post(
      Config.baseApiUrl + "orders/" + this.props.formTypeId,
      null,
      config
    );
  }

  cartTotal(cart) {
    let total = 0;
    cart.forEach((item) => {
      if (item.quantity > 0 && item.price > 0) {
        total += item.price * item.quantity;
      }
    });

    return total;
  }

  formatPrice(price) {
    return Number(price).toFixed(2);
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();
    return (
      <>
        <div
          className={`reviewWrapper ${
            this.props.isBilateral ? "bilateralWrapper" : ""
          }`}
        >
          {!this.props.isBilateral && (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormTitle
                title="Order Review"
                description=""
              />
            </div>
          )}

          <div className="reviews">
            <div>
              {!this.props.showOrderSummary && (
                <div className="summaryName">
                  <h4>Order Summary</h4>
                  {this.props.isBilateral && (
                    <div className="bileralName">
                      <h2>{this.props.bilateralName}</h2>
                    </div>
                  )}
                  {!this.props.isBilateral && <h2>{this.props.formName}</h2>}
                </div>
              )}
              <div className="summaaryHeader">
                <h2>
                  {this.props.name}
                  {this.props.isBilateral &&
                    " (Order " + this.props.orderNumber + ")"}
                </h2>
                <div className="poDate">
                  <div className="po">
                    <span>PO:</span>
                    <p>{this.state.poNumber}</p>
                  </div>
                  {parseInt(this.props.formTypeId) === this.linerBundleFormTypeId ? <></> :
                    <div className="po">
                      <span>SSD:</span>
                      <p>{this.formatShipDate(this.state.estimatedShipDate)}</p>
                    </div>}
                </div>
              </div>
            </div>

            <div className="information">
              <div className="subDetail">
                <h3>Products</h3>

                <div className="detailWrapper flex-wrap">
                  {this.state.cartData.map(item => {
                    return (
                      <div key={item.partNumber} className="detail">
                        <div className="detailContentWrapper">
                          <div className="content">
                            <p>
                              {item.name}
                            </p>
                          </div>
                          <div className="content">
                            <span>Part Number:</span>
                            <p>
                              {item.partNumber}
                            </p>
                          </div>
                          <div className="content">
                            <span>Quantity:</span>
                            <p>
                              {item.quantity}
                            </p>
                          </div>
                          {parseInt(this.props.formTypeId) === this.linerBundleFormTypeId ? 
                          <div className="content">
                            <span>Scheduled Ship Date:</span>
                            <p style={{ alignContent: "end" }}>
                              {item.scheduledShipDate}
                            </p>
                          </div> : <></>}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>

            {!this.props.showOrderInfo && (
              <div className="information">
                <h3>Clinic Info</h3>
                <div className="patientInfo">
                  <div className="customerInfo">
                    <div className="patientSubInfo">
                      <span>Bill to account:</span>
                      <p>{this.state.accountNumber}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinic:</span>
                      <p>{this.state.clinicName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Clinician Name:</span>
                      <p>{this.state.prosthetistName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Email Address</span>
                      <p>{this.state.email}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Phone</span>
                      <p>{this.state.phone}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="information">
              <h3>Shipping Information</h3>
              <div className="patientInfo">
                <div className="">
                  <div className="borderBotom shippingInfo">
                    <div className="patientSubInfo">
                      <span>Shipping Address Line 1:</span>
                      <p>{this.state.shippingAddress1}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Shipping Address Line 2:</span>
                      <p>{this.state.shippingAddress2}</p>
                    </div>
                  </div>

                  <div className="shipping info">
                    <div className="patientSubInfo">
                      <span>State:</span>
                      <p>{this.state.stateName}</p>
                      <span>City:</span>
                      <p>{this.state.city}</p>
                      <span>Shipping Method:</span>
                      <p>{this.state.shippingMethodName}</p>
                    </div>
                    <div className="patientSubInfo">
                      <span>Zip Code:</span>
                      <p>{this.state.zip}</p>
                      <span>Carrier:</span>
                      <p>{this.state.shippingCarrierName}</p>
                    </div>
                  </div>
                </div>
              </div>
              </div>

              {this.state.cartData.length > 0 ? (
                <div className="information">
                  <div className="mb-3"><h3>Cart</h3></div>
                  <div className="patientInfo">
                    <div className="patientSubInfo">
                      <table className="transparent-table table">
                        <thead>
                          <tr>
                            <th><span><b>Name</b></span></th>
                            <th></th>
                            <th><span><b>Part Number</b></span></th>
                            <th><span><b>Quantity</b></span></th>
                            <th className="text-right"><span><b>Price</b></span></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.cartData.map(item => {
                            return (
                              <tr key={item.partNumber}>
                                <td lg="6" sm="1">
                                  <div className="content">
                                    <p style={{ "whiteSpace": "break-spaces" }}>{item.name}</p>
                                  </div>
                                </td>
                                <td></td>
                                <td>
                                  <p>{item.partNumber}</p>
                                </td>
                                <td>
                                  <p>{item.quantity}</p>
                                </td>
                                <td>
                                  <p className="text-right">${this.formatPrice(item.price)}</p>
                                </td>
                              </tr>
                            )
                          })}
                          <tr>
                            <td>
                              <div>
                                <span><b>Total</b></span>
                              </div>
                            </td>
                            <td colSpan={4}>
                              <p className="text-right">
                                ${this.formatPrice(this.cartTotal(this.state.cartData))}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : <></>}

            </div>
        </div>
        </div>
        {this.getNavButtons(this.props.uniqueId)}
        
      </>
    );
  }

  getNavButtons(uniqueId) {
    if (uniqueId != null) {
      return;
    }
  
    return (
      <div className="handelButtons">
            <div className="stepBtn">
              <SecondaryButton
                text="Back"
                onClick={() =>
                  this.props.handleBack(this?.props?.currentIndex - 1)
                }
                disabled={
                  this.props.activeOuterStep == 0 && this.props.innerStep == 0
                }
              />
              <Button
                text="Submit"
                disabled={this.state.isLoading}
                onClick={() => {
                  this.saveData();
                  this.props.handleNext(this?.props?.currentIndex);
                }}
              />
            </div>
          </div>
    );
  }
  
}


export default SimpleCartReview;
